var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Updates-March-2022",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Purchase-Successful",
    transform: "translate(-356.000000, -609.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(100.000000, 287.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Large-Green-Button-Copy-3",
    transform: "translate(225.000000, 304.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(31.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C5.372583,0 0,5.372583 0,12 C0,18.627417 5.372583,24 12,24 C18.627417,24 24,18.627417 24,12 C23.9960281,5.37422891 18.6257711,0.00397188903 12,0 Z M17.1349091,14.9530909 L12.7712727,19.3167273 C12.566768,19.5213749 12.2893144,19.6363567 12,19.6363567 C11.7106856,19.6363567 11.433232,19.5213749 11.2287273,19.3167273 L6.86509091,14.9530909 C6.58150191,14.6791915 6.46776808,14.2735878 6.5676031,13.8921738 C6.66743813,13.5107599 6.96530536,13.2128927 7.34671928,13.1130576 C7.72813321,13.0132226 8.13373694,13.1269565 8.40763636,13.4105455 L10.9090909,15.9118909 L10.9090909,5.45454545 C10.9090909,4.852053 11.3975075,4.36363636 12,4.36363636 C12.6024925,4.36363636 13.0909091,4.852053 13.0909091,5.45454545 L13.0909091,15.9118909 L15.5923636,13.4105455 C16.0204133,12.9971212 16.7008198,13.0030338 17.1216203,13.4238343 C17.5424208,13.8446348 17.5483333,14.5250412 17.1349091,14.9530909 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.03f7aa272dcd49f407281bc4c187eeba.svg";
export { ForwardRef as ReactComponent };